import * as React from 'react';
import { useSelector } from 'react-redux';
import { Avatar, Flex, Spacer, Title, cn } from '@siteground/styleguide';
import { getOperatorInfo } from '../../selectors/operator';
import './chat-header.css';

const ChatHeader = () => {
  const operator = useSelector(getOperatorInfo);

  const { first_name, last_name, avatar } = operator;
  const classes = cn('chat-header');

  return (
    <Flex className={classes} wrap="nowrap">
      <Avatar size="42" firstName={first_name} lastName={last_name} src={avatar} />

      <Spacer size="x-small" />

      <Flex align="center" wrap="nowrap">
        <Title className="chat-header__title" level="4" truncate>
          {first_name} {last_name}
        </Title>
      </Flex>
    </Flex>
  );
};

export default ChatHeader;
